<template>

    <b-card>
        <b-row slot="header">
            <b-col xs="12" class="d-flex flex-row justify-content-between align-items-center">
                <div>Incidencias</div>
                <div>
                    <button
                        v-if="$_rolesMixin_checkRoles([roles.advisoryChief, roles.advisoryStaff]) && !hideAddIssueButton"
                        class="btn btn-primary btn-sm"
                        @click="openQueryIssueModal">
                        <i class="fa fa-plus mr-2"></i>Nueva Incidencia
                    </button>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">

                <v-client-table
                    ref="QueryIssuesTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="queryIssues"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <button
                            v-if="mixinCheckPermission('QUERY_ISSUE_DELETE')"
                            v-b-tooltip.hover.top
                            title="Eliminar"
                            class="btn p-0"
                            @click="deleteQueryIssue(props.row.uuid)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>

                    <template slot="user" slot-scope="props">
                        {{props.row.user.name}}
                    </template>

                    <template slot="type" slot-scope="props">
                        {{props.row.type.description}}
                    </template>

                    <template slot="createdAt" slot-scope="props">
                        {{props.row.createdAt | dateFormat('DD/MM/YYYY HH:mm')}}
                    </template>

                </v-client-table>

            </b-col>
        </b-row>

        <b-modal
            ref="newIssueModal"
            title="Añadir Incidencia"
            hide-footer>

            <template>

                <b-form @submit.prevent="addQueryIssue">

                    <div class="px-4">

                        <b-row>

                            <multiselect
                                v-model="newQueryIssue.type"
                                :options="queryIssueTypesOptions"
                                :custom-label="option => option.description"
                                :multiple="false"
                                :allowEmpty="true"
                                placeholder="Tipo de incidencia"
                                selectLabel="+"
                                deselectLabel="-"
                                v-if="queryIssueTypes">
                            </multiselect>

                        </b-row>

                        <b-row class="py-3">
                            <b-form-textarea id="description"
                                v-model="newQueryIssue.description"
                                placeholder="Describa la incidencia"
                                :rows="3"
                                :max-rows="6">
                            </b-form-textarea>
                        </b-row>

                        <b-row class="pb-3">
                            <b-col md="10" class="align-content-center">
                                <span class="gray-text">Enviar notificación al departamento de consultas</span>
                            </b-col>
                            <b-col md="2">
                                <toggle-button
                                    color="#025542"
                                    :sync="true"
                                    v-model="newQueryIssue.sendToQueryDepartment"
                                    :labels="{checked: 'Si', unchecked: 'No'}"/>
                            </b-col>
                        </b-row>

                    </div>

                    <b-row class="border-top pt-3 px-3 flex-row-reverse">
                        <button
                            type="submit"
                            class="btn btn-brand btn-primary col-auto btn-lg float-right"
                            :disabled="!newQueryIssue.type || !newQueryIssue.description">
                            Guardar
                        </button>
                    </b-row>

                </b-form>

            </template>
        </b-modal>

    </b-card>

</template>

<script>

    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import Multiselect from 'vue-multiselect';
    import form from '@/helpers/form';
    import {roles} from '@/constants/roles-constants';
    import {getQueryIssues, addQueryIssue} from '@/api/query-api';
    import {getQueryIssueTypes} from '@/api/query-issue-type-api';
    import {deleteQueryIssue} from '@/api/query-issue-api';

    Vue.use(ClientTable);

    export default {
        name: "QueryIssues",
        props: {
            value: Array,
            hideAddIssueButton: {
                type: Boolean,
                default: false
            },
            queryId: String
        },
        components: {Multiselect},
        data: function () {
            return {
                roles,
                queryIssues: [],
                queryIssueTypes: [],
                newQueryIssue: {
                    type: null,
                    description: null,
                    sendToQueryDepartment: null
                },
                columns: ['uuid', 'user', 'type', 'description', 'createdAt'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        user: 'Asesor',
                        type: 'Tipo',
                        description: 'Descripción',
                        createdAt: 'Fecha',
                    },
                    sortable: [],
                    filterable: [],
                    texts: form.tableLabels(),
                    perPage: 5,
                    pagination: {
                        edge: true,
                        nav: 'scroll'
                    }
                },
                theme: 'bootstrap4',
            }
        },
        mounted() {
            this.loadQueryIssues();
            getQueryIssueTypes().then((queryIssueTypes) => this.queryIssueTypes = queryIssueTypes);
        },
        methods: {
            loadQueryIssues() {
                getQueryIssues(this.queryId).then((queryIssues) => {
                    this.queryIssues = queryIssues;
                    this.$emit('input', this.queryIssues);
                });
            },
            async addQueryIssue() {
                this.$refs.newIssueModal.hide();
                this.$_loadingMixin_showLoading();
                await addQueryIssue(this.queryId, this.newQueryIssue.type.uuid, this.newQueryIssue.description, this.newQueryIssue.sendToQueryDepartment)
                    .then(() => {
                        this.loadQueryIssues();
                    })
                    .catch((error) => {
                        this.$_notificationMixin_error('Incidencia no almacenada', error);
                    });
                this.$_loadingMixin_hideLoading();
            },
            async deleteQueryIssue(queryIssueId) {
                console.log(queryIssueId);
                swal({
                    title: '¿Estás seguro de eliminar la incidencia seleccionada?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, elimínala!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();

                        deleteQueryIssue(queryIssueId)
                            .then((data) => {
                                this.loadQueryIssues();
                            })
                            .catch((error) => {
                                this.showErrorWhenNotSaveData();
                            });

                        this.$_loadingMixin_hideLoading();

                    }
                });
            },
            openQueryIssueModal() {
                this.newQueryIssue = {
                    type: null,
                    description: null,
                    sendToQueryDepartment: true
                };
                this.$refs.newIssueModal.show();
            }
        },
        computed: {
            queryIssueTypesOptions() {
                return this.queryIssueTypes.filter((issueType) => issueType.active)
            }
        }
    }
</script>

<style>
    .gray-text, .multiselect__placeholder {
        color: #73828f;
    }
</style>
